import { logger as garnishLogger } from '@garnish/logger';
import { assign } from 'xstate';

import {
  type Action,
  type ClaimErrorType,
  type ClaimOfferResponse,
} from '../click-to-claim.machine.types';

// ─── Actions ─────────────────────────────────────────────────────────────────

const assignClaimedReward: Action<ClaimOfferResponse> = assign((_args, params) => {
  if (params.result !== 'Reward') return {};

  return { reward: params.reward };
});

// ─── Outcome Actions ─────────────────────────────────────────────────────────

const onClaimSucceeded: Action = () => {};

const onClaimFailed: Action<{ failureReason: ClaimErrorType }> = () => {};

// ─── Log Actions ─────────────────────────────────────────────────────────────

const logSuccessfulClaim: Action = ({ context }) => {
  clickToClaimMachineLog.info('Successfully claimed an offer', {
    offerId: context.offerId,
    rewardId: context.reward?.id,
  });
};

const logFailedClaim: Action<{ errorMessage: string | undefined }> = ({ context }, params) => {
  clickToClaimMachineLog.error('Failed to claim an offer', {
    offerId: context.offerId,
    errorMessage: params.errorMessage,
  });
};

const logFailedClaimDueToUserError: Action<{
  errorType: ClaimErrorType;
  errorMessage: string | undefined;
}> = ({ context }, params) => {
  clickToClaimMachineLog.warn('Failed to claim an offer due to user error', {
    errorType: params.errorType,
    offerId: context.offerId,
    errorMessage: params.errorMessage,
  });
};

// ─────────────────────────────────────────────────────────────────────────────

export const Actions = {
  assignClaimedReward,

  onClaimSucceeded,
  onClaimFailed,

  logSuccessfulClaim,
  logFailedClaim,
  logFailedClaimDueToUserError,
};

// ─── Logger ──────────────────────────────────────────────────────────────────

export const clickToClaimMachineLog = garnishLogger.extend('CLICK_TO_CLAIM_MACHINE');
